<template>
  <transition name="modal">
    <div
      class="map-modal"
      id="map-modal"
      @click="handleOutsideClick"
      v-if="showModal"
    >
      <transition name="modal-content">
        <div class="location-map" style="min-width: 450px">
          <gmap-map
            :zoom="14"
            :center="center"
            style="width: 100%; height: 600px"
          >
           
          </gmap-map>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    lat: {
      default: 0,
    },
    long: {
      default: 0,
    },
  },
  components: {
    // DirectionRender
  },
  computed: {
    origin() {
      return {
        lat: this.lat ? this.lat : 0,
        lng: this.long ? this.long : 0,
      };
    },
    destination() {
      return {
        lat: this.lat ? this.lat : 0,
        lng: this.long ? this.long : 0,
      };
    },
  },
  data() {
    return {
      locationMarkers: [],
      locPlaces: [],
      existingPlace: null,
    };
  },

  mounted() {
    this.center = {
      lat: this.lat,
      lng: this.long,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    handleOutsideClick() {
      let modal = document.getElementById("map-modal");
      if (event.target == modal) {
        this.$emit("close-modal");
      }
    },
  },
};
</script>

<style scoped>
.map-modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease 0.5s;
}

/* Modal Content/Box */
.custom-modal-content {
  background-color: #ffffff;
  padding: 1.5rem;
  border: 1px solid #888;
  width: 40%;
  border-radius: 6px;
  overflow-y: auto;
}

.modal-heading {
  display: flex;
  justify-content: space-between;
  border-bottom: 0.2px solid #a3a4a7;
  padding-bottom: 1rem;
}

.modal-heading h1 {
  font-weight: bold;
  font-size: 1rem;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.modal-enter-to,
.modal-leave {
  opacity: 1;
  transform: translateY(0);
}

.modal-enter-active,
.modal-leave-active {
  transition: all ease 0.5s;
}

@media screen and (max-width: 768px) {
  .custom-modal-content {
    width: 100% !important;
    padding: 0.5rem;
  }
}
</style>
